import { Directive, HostListener, Input, inject } from '@angular/core';
import { ENUM_ActivityEventType } from '@api-new/common';
import { Store } from '@ngrx/store';
import { logAnalyticsEvent } from '../store/analytics/analytics.actions';

@Directive({
  selector: '[activityLogClick]',
  standalone: true,
})
export class ActivityLogClickDirective {
  @Input('activityLogClick') eventName: string | null;

  private store = inject(Store);

  @HostListener('click') onMouseClick(): void {
    if (this.eventName) {
      this.store.dispatch(
        logAnalyticsEvent({
          event: {
            type: ENUM_ActivityEventType.ACTIVITY_EVENT_TYPE_CLICK,
            name: this.eventName,
          },
        }),
      );
    }
  }
}
